import React from 'react';
import { Container } from 'reactstrap';
import classNames from 'classnames';
import NeedHelp from '../../../components/modals/NeedHelp/NeedHelp';
import styles from './FlexFooter.module.css';

const FlexFooter = () => {
    return (
        <>
            <Container className={classNames(styles.footerText, 'px-3')}>
                <p>
                    Service Plans are sold by Flex Embedded, Inc.; issued by AIG WarrantyGuard, Inc., except in Florida
                    and Oklahoma where it is AIG Warranty Services of Florida, Inc.; and administered by Service Net
                    Warranty, LLC. Service Plans may not be available in all states. Limitations and exclusions apply.
                    Terms and conditions for Service Plans are available at{' '}
                    <a
                        href='https://flexprotect.serviceplans.com/coveragedocs'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='ml-1 mr-1'
                    >
                        {' '}
                        https://flexprotect.serviceplans.com/coveragedocs
                    </a>
                    .
                </p>
                <p>
                    AIG WarrantyGuard, Inc., AIG Warranty Services of Florida, Inc., and Service Net Warranty are
                    affiliates of AIG. AIG is the marketing name for the worldwide property-casualty and general
                    insurance operations of American International Group, Inc.
                </p>
                <p>
                    All trademarks, logos and brand names are the property of their respective owners. All rights
                    reserved.
                </p>
            </Container>
            <footer className={styles.flexFooter}>
                <Container className={classNames(styles.footerPadding, 'px-0')}>
                    <ul className={styles.navItem}>
                        <li>
                            <a
                                href='https://www.aig.com/privacy-policy'
                                target='_blank'
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/terms-of-use'
                                target='_blank'
                            >
                                Terms of Use
                            </a>
                        </li>
                    </ul>
                    <p>
                        Copyright &#169; {new Date().getFullYear()}, American International Group, Inc. All rights
                        reserved.
                    </p>
                </Container>
                <NeedHelp />
            </footer>
        </>
    );
};

export default FlexFooter;
